import {defineStore} from "pinia";
import {DataPanelClues, statePanel} from "@/page/quiz/typeQuiz";

export const usePanelStore = defineStore("panelData", {
  state: (): statePanel => ({
    isShowQuestionSettingPanel: false,
    dataPanelClues: {
      name: "",
      category: "",
      index: -1
    }
  }),

  actions: {
    setDataPanelClues(dataPanelClues: DataPanelClues): void {
      this.dataPanelClues = {
        name: dataPanelClues.name,
        category: dataPanelClues?.category,
        index: dataPanelClues.index
      };
    },

    openSettingPanel(dataPanelClues: DataPanelClues): void {
      this.dataPanelClues = {
        name: dataPanelClues.name,
        category: dataPanelClues?.category ?? "",
        index: dataPanelClues.index
      };
      this.isShowQuestionSettingPanel = true;
    },

    closeSettingPanel(): void {
      this.isShowQuestionSettingPanel = false;
      this.dataPanelClues = {
        name: "",
        category: "",
        index: -1
      };
    }
  },

  getters: {
    getIsShowQuestionSettingPanel: (state: statePanel): boolean =>
      state.isShowQuestionSettingPanel,
    getDataPanelClues: (state: statePanel): DataPanelClues =>
      state.dataPanelClues
  }
});
